import { render, staticRenderFns } from "./coupon_list.vue?vue&type=template&id=57f523a0&scoped=true&"
import script from "./coupon_list.vue?vue&type=script&lang=js&"
export * from "./coupon_list.vue?vue&type=script&lang=js&"
import style0 from "./coupon_list.vue?vue&type=style&index=0&id=57f523a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f523a0",
  null
  
)

export default component.exports